import React, { PureComponent, lazy } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";

import logo from "./logo.png";
import "./App.scss";
import { withSuspense } from "./loader/Loader";

const Login = lazy(() => import("./login/Login"));
const PlaylistGenerator = lazy(
  () => import("./playlist-generator/PlaylistGenerator")
);

// Get the hash of the url
const hash = window.location.hash
  .substring(1)
  .split("&")
  .reduce((initial: any, item) => {
    if (item) {
      var parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);
    }
    return initial;
  }, {});
window.location.hash = "";

interface Props {}
interface State {
  token?: string;
}

export default class App extends PureComponent<Props, State> {
  state: State = {
    token: undefined,
  };

  componentDidMount() {
    // Set token
    let _token = hash.access_token;
    if (_token) {
      // Set token
      this.setState({
        token: _token,
      });
    }
  }

  render() {
    return (
      <>
        <Container className="mb-3">
          <Row>
            <Col>
              <Row className="mt-5 mb-5">
                <Col className="header-container">
                  <h1>
                    Spotishakr <Image src={logo} width="70vw" />
                  </h1>
                  <h4>
                    <i>Generate playlists with ease</i>
                  </h4>
                  {!this.state.token && (
                    <div className="login-container">
                      {withSuspense(<Login></Login>)}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  {this.state.token &&
                    withSuspense(
                      <PlaylistGenerator
                        token={this.state.token}
                      ></PlaylistGenerator>
                    )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <footer className="footer">
          <Container>
            <p className="text-muted small mb-0">
              &copy; {new Date().getFullYear()} Copyright -{" "}
              <a href="https://www.escemi.com/">ESCEMI</a>
            </p>
          </Container>
        </footer>
      </>
    );
  }
}
